import { AccountDictionaryItem } from '@/models/dictionary/account';
import { useRemoteDictionaryHelpers } from '@/stores/utils/useRemoteDictionaryHelpers';
import { IAccountDictionaryApi } from '@/types';

export const useAccountDictionary = defineStore('accountDictionary', () => {
    const itemsAll = shallowRef<AccountDictionaryItem[]>([]);

    const { itemById, nameById } = useRemoteDictionaryHelpers(itemsAll);

    // actions
    function setData(data: IAccountDictionaryApi[]) {
        console.time('set-account-dictionary');
        itemsAll.value = data.map((item) => new AccountDictionaryItem(item));
        console.timeEnd('set-account-dictionary');
    }

    const items = computed(() => itemsAll.value);

    return {
        items,
        itemById,
        nameById,
        setData,
    };
});
